export const equipTable = {
  wrapper: 'border rounded-lg border-ld overflow-hidden bg-background',
  table: 'min-w-full w-full',
  thead: 'sticky top-0 z-10 bg-muted',
  theadTr: 'border-b border-ld',
  th: 'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap',
  tr: 'border-b last:border-b-0 border-ld hover:bg-muted/50',
  trClickable: 'border-b last:border-b-0 border-ld cursor-pointer hover:bg-muted/50',
  trAlt: (index: number) => (index % 2 === 1 ? 'bg-muted/30' : ''),
  td: 'px-4 py-2 text-sm whitespace-nowrap',
  stickyTh: 'sticky left-0 z-20 bg-muted after:absolute after:right-0 after:top-0 after:bottom-0 after:w-px after:bg-border',
  // bg-background must be solid (no opacity modifier) so scrolled content cannot bleed through.
  // group-hover mirrors the tr hover color on the sticky cell.
  stickyTd: 'sticky left-0 z-10 bg-background group-hover:[background-color:color-mix(in_srgb,var(--muted)_50%,var(--background))] after:absolute after:right-0 after:top-0 after:bottom-0 after:w-px after:bg-border',
  // color-mix produces the solid equivalent of bg-muted/30 over bg-background — no transparency,
  // so the sticky cell fully blocks content scrolling behind it.
  // Use var(--muted) directly (not hsl(var(--muted))) since --muted may be oklch/hex, not bare HSL values.
  stickyTdAlt: 'sticky left-0 z-10 [background-color:color-mix(in_srgb,var(--muted)_30%,var(--background))] group-hover:[background-color:color-mix(in_srgb,var(--muted)_50%,var(--background))] after:absolute after:right-0 after:top-0 after:bottom-0 after:w-px after:bg-border',
}
